<script>
import { BPagination } from "bootstrap-vue";

export default {
  extends: BPagination
};
</script>